// bar 中的过滤表单配置
export const formItem = {
  map: (params) => ({
    type: "map",
    ...params,
  }),
  select: (params) => ({
    type: "select",
    ...params,
  }),
  checkbox: (params) => ({
    type: "checkbox",
    ...params,
  }),
  checkboxGroup: (params) => ({
    type: "checkboxGroup",
    ...params,
  }),
  input: (params) => ({
    type: "input",
    ...params,
  }),
  textarea: (params) => ({
    type: "textarea",
    ...params,
  }),
  date: (params) => ({
    type: "date",
    ...params,
  }),
  datetime: (params) => ({
    type: "datetime",
    ...params,
  }),
  daterange: (params) => ({
    type: "daterange",
    ...params,
  }),
  monthrange: (params) => ({
    type: "monthrange",
    ...params,
  }),
  datetimerange: (params) => ({
    type: "datetimerange",
    ...params,
  }),

  tag: (params) => ({
    type: "tag",
    ...params,
  }),
  radio: (params) => ({
    type: "radio",
    ...params,
  }),
  radioGroup: (params) => ({
    type: "radioGroup",
    ...params,
  }),
  defaultType: (params) => ({
    type: "defaultType",
    ...params,
  }),
  image: (params) => ({
    type: "image",
    ...params,
  }),
  upload: (params) => ({
    type: "upload",
    ...params,
  }),
  import: (params) => ({
    type: "import",
    ...params,
  }),
  colorPick: (params) => ({
    type: "colorPick",
    ...params,
  }),
  numberPick: (params) => ({
    type: "numberPick",
    ...params,
  }),
  title: (params) => ({
    type: "title",
    ...params,
  }),
};
// 手机号码 /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/
export const mobilePattern = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
// 密码
export const passwordPattern = /^([A-Za-z0-9`~!@#\\$%\\^&\\*\\)\\(\\+-,\\.\\?;']){6,16}$/
// 身份证
export const idCardPattern = /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/
// 邮箱
export const emailPattern = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
// 中文
export const namePattern = /^[\u4e00-\u9fa5]{2,4}$/
// 统一社会信用代码
export const codePattern = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/

// 经度
export const longrg = /^[\-\+]?(0?\d{1,2}(\.\d{1,9})*|1[0-7]?\d{1}(\.\d{1,9})*|180(\.0{1,9})*)$/

// 纬度
export const latreg = /^[\-\+]?([0-8]?\d{1}(\.\d{1,9})*|90(\.0{1,9})*)$/


// 飞行器管理
export const aircraftFilterForm = [
  formItem.input({
    prop: "series",
    label: "飞行器编号",
    placeholder: "请输入飞行器编号",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "subordinateCompany",
    label: "飞行器所属公司",
    options: [],
    placeholder: "请选择飞行器所属公司",
    defaultVal: undefined,
  }),
];
export const aircraftDrawerForm = [
  formItem.title({
    label: "基本信息",
  }),
  formItem.input({
    prop: "series",
    label: "飞行器编号",
    placeholder: "请输入飞行器编号",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "subordinateCompany",
    label: "飞行器所属公司",
    options: [],
    placeholder: "请选择飞行器所属公司",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "purpose",
    label: "飞行器用途",
    options: [
      {
        label: "载人",
        value: "载人",
      },
      {
        label: "载物",
        value: "载物",
      },
    ],
    placeholder: "请选择飞行器用途",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "deviceNumber",
    label: "飞行器设备号",
    placeholder: "请输入飞行器设备号",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "deviceMmsi",
    label: "飞行器MMSI",
    placeholder: "请输入飞行器MMSI",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "videoUrl",
    label: "飞行器监控视频流地址",
    placeholder: "视频流地址",
    defaultVal: undefined,
  }),
  formItem.upload({
    prop: "devicePictures",
    label: "飞行器图片",
    defaultVal: [],
    limitNum: 9,
  }),
  formItem.input({
    prop: "contactPerson",
    label: "飞行器联络人",
    placeholder: "请输入飞行器联络人",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "region",
    label: "飞行器所属区域",
    placeholder: "请输入飞行器所属区域",
    defaultVal: undefined,
  }),
  formItem.title({
    label: "基本参数",
  }),

  formItem.input({
    prop: "maxFlyWeight",
    label: "最大起飞重量（kg）",
    placeholder: "请输入最大起飞重量（kg）",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "flyMachineDiameter",
    label: "机身最大直径（m）",
    placeholder: "请输入机身最大直径（m）",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "maxEmptyFlyWeight",
    label: "最大空机重量（kg）",
    placeholder: "请输入最大空机重量（kg）",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "maxFlyTime",
    label: "最大续航时长（min）",
    placeholder: "请输入最大续航时长（min）",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "maxFlySpeed",
    label: "最高飞行速度（kts）",
    placeholder: "请输入最高飞行速度（kts）",
    defaultVal: undefined,
  }),
  formItem.numberPick({
    prop: "loadPeopleNum",
    label: "核载人数（人）",
    placeholder: "请输入核载人数（人）",
    defaultVal: undefined,
  }),
];
export const aircraftDrawerFormRules = {
  series: [
    {
      required: true,
      message: "请输入设施设备类型",
      trigger: "blur",
    },
  ],
  region: [
    {
      required: true,
      message: "请输入飞行器所属区域",
      trigger: "blur",
    },
  ],
  subordinateCompany: [
    {
      required: true,
      message: "请选择飞行器所属公司",
      trigger: "blur",
    },
  ],
  purpose: [
    {
      required: true,
      message: "请选择飞行器用途",
      trigger: "blur",
    },
  ],
  deviceNumber: [
    {
      required: true,
      message: "请输入飞行器设备号",
      trigger: "blur",
    },
  ],
  deviceMmsi: [
    {
      required: true,
      message: "请输入飞行器MMSI",
      trigger: "blur",
    },
  ],
  devicePictures: [
    {
      required: true,
      message: "请上传飞行器图片",
      trigger: "blur",
    },
  ],
  contactPerson: [
    {
      required: true,
      message: "请输入飞行器联络人",
      trigger: "blur",
    },
  ],
  maxFlyWeight: [
    {
      required: true,
      message: "请输入最大起飞重量（kg）",
      trigger: "blur",
    },
  ],
  flyMachineDiameter: [
    {
      required: true,
      message: "请输入机身最大直径（m）",
      trigger: "blur",
    },
  ],
  maxEmptyFlyWeight: [
    {
      required: true,
      message: "请输入最大空机重量（kg）",
      trigger: "blur",
    },
  ],
  maxFlyTime: [
    {
      required: true,
      message: "请输入最大续航时长（min）",
      trigger: "blur",
    },
  ],
  maxFlySpeed: [
    {
      required: true,
      message: "请输入最高飞行速度（kts）",
      trigger: "blur",
    },
  ],
  loadPeopleNum: [
    {
      required: true,
      message: "请输入核载人数（人）",
      trigger: "blur",
    },
  ],
};

// 设施设备类型管理
export const facilityTypeFilterForm = [
  formItem.input({
    prop: "typeName",
    label: "设施设备类型",
    placeholder: "请输入设施设备类型名称",
    defaultVal: undefined,
  }),
];
export const facilityTypeDrawerForm = [
  formItem.input({
    prop: "name",
    label: "设施设备类型",
    placeholder: "请输入设施设备类型",
    defaultVal: undefined,
  }),
  formItem.upload({
    prop: "iconPath",
    label: "图标",
    defaultVal: [],
  }),

  formItem.radio({
    prop: "isRange",
    label: "是否涉及范围",
    options: [
      {
        label: "是",
        value: "是",
      },
      {
        label: "否",
        value: "否",
      },
    ],
    defaultVal: undefined,
  }),
  formItem.colorPick({
    prop: "color",
    label: "范围填充颜色",
    defaultVal: undefined,
  }),
];
export const facilityTypeDrawerFormRules = {
  name: [
    {
      required: true,
      message: "请输入设施设备类型",
      trigger: "blur",
    },
  ],
  isRange: [
    {
      required: true,
      message: "请选择是否涉及范围",
      trigger: "blur",
    },
  ],
  iconPath: [
    {
      required: true,
      message: "请上传图标",
      trigger: "blur",
    },
  ],
};

// 地面资源类型管理
export const groundResourcesTypeFilterForm = [
  formItem.input({
    prop: "typeName",
    label: "地面资源类型",
    placeholder: "请输入地面资源类型",
    defaultVal: undefined,
  }),
];
export const groundResourcesTypeDrawerForm = [
  formItem.input({
    prop: "name",
    label: "地面资源类型",
    placeholder: "请输入地面资源类型",
    defaultVal: undefined,
  }),
  formItem.upload({
    prop: "iconPath",
    label: "图标",
    defaultVal: [],
    limitNum: 1,
  }),
];
export const groundResourcesTypeDrawerFormRules = {
  name: [
    {
      required: true,
      message: "请输入地面资源类型",
      trigger: "blur",
    },
  ],
  iconPath: [
    {
      required: true,
      message: "请上传图标",
      trigger: "blur",
    },
  ],
};
// 地面资源数据管理
export const groundResourcesDataFilterForm = [
  formItem.input({
    prop: "name",
    label: "地面资源名称",
    placeholder: "请输入地面资源名称",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "typeName",
    label: "地面资源类型",
    options: [],
    placeholder: "请选择地面资源类型",
    defaultVal: undefined,
  }),
];
export const groundResourcesDataDrawerForm = [
  formItem.input({
    prop: "name",
    label: "地面资源名称",
    placeholder: "请输入地面资源名称",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "typeName",
    label: "地面资源类型",
    options: [],
    placeholder: "请选择地面资源类型",
    defaultVal: undefined,
  }),
  formItem.radio({
    prop: "lonLatTypeRadio",
    label: "坐标",
    options: [
      {
        label: "度分秒/DSM",
        value: "度分秒/DSM",
      },
      {
        label: "小数DD",
        value: "小数DD",
      },
    ],
    defaultVal: "小数DD",
  }),
  formItem.input({
    prop: "lon",
    label: "经度",
    placeholder: "请输入经度",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "lat",
    label: "纬度",
    placeholder: "请输入纬度",
    defaultVal: undefined,
  }),
  formItem.textarea({
    prop: "mark",
    label: "备注",
    placeholder: "请输入备注",
    defaultVal: undefined,
  }),
];
export const groundResourcesDataDrawerFormRules = {
  name: [
    {
      required: true,
      message: "请输入地面资源名称",
      trigger: "blur",
    },
  ],
  typeName: [
    {
      required: true,
      message: "请选择地面资源类型",
      trigger: "blur",
    },
  ],
  lon: [
    {
      required: true,
      message: "请输入经度",
      trigger: "blur",
      
    },
    {
      pattern: longrg,
      message: '请输入在正确的经纬度',
      trigger: 'blur'
    }
  ],
  lat: [
    {
      required: true,
      message: "请输入纬度",
      trigger: "blur",
    },
    {
      pattern: latreg,
      message: '请输入在正确的经纬度',
      trigger: 'blur'
    }
  ],
};

// 设施设备数据管理
export const facilityDataFilterForm = [
  formItem.input({
    prop: "name",
    label: "设施设备名称",
    placeholder: "请输入设施设备名称",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "typeName",
    label: "设施设备类型",
    options: [],
    placeholder: "请选择设施设备类型",
    defaultVal: undefined,
  }),
];
export const facilityDataDrawerForm = [
  formItem.input({
    prop: "name",
    label: "设施设备名称：",
    placeholder: "请输入设施设备名称",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "typeName",
    label: "设施设备类型",
    options: [],
    placeholder: "请选择设施设备类型",
    defaultVal: undefined,
  }),
  formItem.radio({
    prop: "lonLatTypeRadio",
    label: "坐标",
    options: [
      {
        label: "度分秒/DSM",
        value: "度分秒/DSM",
      },
      {
        label: "小数DD",
        value: "小数DD",
      },
    ],
    defaultVal: "小数DD",
  }),
  formItem.input({
    prop: "lon",
    label: "经度",
    placeholder: "请输入经度",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "lat",
    label: "纬度",
    placeholder: "请输入纬度",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "radius",
    label: "覆盖范围",
    placeholder: "请输入范围（单位为海里）",
    defaultVal: undefined,
  }),
  formItem.textarea({
    prop: "mark",
    label: "备注",
    placeholder: "请输入备注",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "inputUrl",
    label: "数据接入",
    placeholder: "请输入URL",
    defaultVal: undefined,
  }),
];
export const facilityDataDrawerFormRules = {
  name: [
    {
      required: true,
      message: "请输入设施设备类型",
      trigger: "blur",
    },
  ],
  typeName: [
    {
      required: true,
      message: "请选择设施设备类型",
      trigger: "blur",
    },
  ],
  lon: [
    {
      required: true,
      message: "请输入经度",
      trigger: "blur",
      
    },
    {
      pattern: longrg,
      message: '请输入在正确的经纬度',
      trigger: 'blur'
    }
  ],
  lat: [
    {
      required: true,
      message: "请输入纬度",
      trigger: "blur",
    },
    {
      pattern: latreg,
      message: '请输入在正确的经纬度',
      trigger: 'blur'
    }
  ],
  radius: [
    {
      required: true,
      message: "请输入覆盖范围",
      trigger: "blur",
    },
  ],
  inputUrl: [
    {
      required: true,
      message: "请输入URL",
      trigger: "blur",
    },
  ],
};

// 空域管理管理
export const airspaceFilterForm = [
  formItem.select({
    prop: "classify",
    label: "空域类型",
    options: [
      {
        label: "管制空域",
        value: "管制空域",
      },
      {
        label: "监视空域",
        value: "监视空域",
      },
      {
        label: "报告空域",
        value: "报告空域",
      },
      {
        label: "目视飞行航线",
        value: "目视飞行航线",
      },
    ],
    placeholder: "请选择空域类型",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "name",
    label: "空域围栏名称",
    placeholder: "请输入空域围栏名称",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "isLaunch",
    label: "是否启动",
    options: [
      {
        label: "是",
        value: "是",
      },
      {
        label: "否",
        value: "否",
      },
    ],
    placeholder: "请选择是否启动",
    defaultVal: undefined,
  }),
];
export const airspaceDrawerForm = [
  formItem.select({
    prop: "classify",
    label: "空域类型",
    options: [
      {
        label: "管制空域",
        value: "管制空域",
      },
      {
        label: "监视空域",
        value: "监视空域",
      },
      {
        label: "报告空域",
        value: "报告空域",
      },
      {
        label: "目视飞行航线",
        value: "目视飞行航线",
      },
    ],
    placeholder: "请选择空域类型",
    defaultVal: undefined,
  }),
  formItem.import({
    prop: "fileUrl",
    label: "数据导入",
    placeholder: "请导入数据",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "name",
    label: "空域围栏名称",
    placeholder: "请输入空域围栏名称",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "warningClass",
    label: "警告类型",
    options: [
      {
        label: "出围栏",
        value: "出围栏",
      },
      {
        label: "进围栏",
        value: "进围栏",
      },
    ],
    placeholder: "请选择警告类型",
    defaultVal: undefined,
  }),
  formItem.checkboxGroup({
    prop: "flyMachineIds",
    label: "关联设备",
    options: [],
    placeholder: "请选择关联设备",
    defaultVal: undefined,
  }),
  formItem.radio({
    prop: "isLaunch",
    label: "是否启动",
    options: [
      {
        label: "是",
        value: "是",
      },
      {
        label: "否",
        value: "否",
      },
    ],
    defaultVal: undefined,
  }),
  formItem.datetimerange({
    prop: "date",
    label: "启动时间",
    placeholder: "请输入启动时间",
    defaultVal: undefined,
  }),
];
export const airspaceDrawerFormRules = {
  classify: [
    {
      required: true,
      message: "请选择空域类型",
      trigger: "blur",
    },
  ],
  fileUrl: [
    {
      required: true,
      message: "请导入数据",
      trigger: "blur",
    },
  ],
  name: [
    {
      required: true,
      message: "请输入空域围栏名称",
      trigger: "blur",
    },
  ],
  warningClass: [
    {
      required: true,
      message: "请选择警告类型",
      trigger: "blur",
    },
  ],
  flyMachineIds: [
    {
      required: true,
      message: "请选择关联设备",
      trigger: "blur",
    },
  ],
  isLaunch: [
    {
      required: true,
      message: "请选择是否启动",
      trigger: "blur",
    },
  ],
};
// 航线管理
export const airApproachControlFilterForm = [
  formItem.input({
    prop: "name",
    label: "航线名称",
    placeholder: "请输入航线名称",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "routeSer",
    label: "航线编号",
    placeholder: "请输入航线编号",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "checkStatus",
    label: "审核状态",
    options: [
      {
        label: "待审核",
        value: "待审核",
      },
      {
        label: "审核中",
        value: "审核中",
      },
      {
        label: "审核通过",
        value: "审核通过",
      },
      {
        label: "审核不通过",
        value: "审核不通过",
      },
    ],
    placeholder: "请选择审核状态",
    defaultVal: undefined,
  }),
];
export const airApproachControlDrawerForm = [
  formItem.select({
    prop: "typeName",
    label: "空域类型",
    options: [],
    placeholder: "请选择空域类型",
    defaultVal: undefined,
  }),
  formItem.import({
    prop: "name",
    label: "数据导入",
    placeholder: "请导入数据",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "name",
    label: "空域围栏名称",
    placeholder: "请输入空域围栏名称",
    defaultVal: undefined,
  }),
  formItem.checkbox({
    prop: "typeName",
    label: "警告类型",
    options: [
      {
        label: "出围栏",
        value: "出围栏",
      },
      {
        label: "进围栏",
        value: "进围栏",
      },
    ],
    placeholder: "请选择警告类型",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "typeName",
    label: "是否启动",
    options: [],
    placeholder: "请选择是否启动",
    defaultVal: undefined,
  }),
  formItem.datetimerange({
    prop: "date",
    label: "启动时间",
    placeholder: "请输入启动时间",
    defaultVal: undefined,
  }),
];
export const airApproachControlDrawerFormRules = {
  name: [
    {
      required: true,
      message: "请输入设施设备类型",
      trigger: "blur",
    },
  ],
  typeName: [
    {
      required: true,
      message: "请选择设施设备类型",
      trigger: "blur",
    },
  ],
  lon: [
    {
      required: true,
      message: "请输入经度",
      trigger: "blur",
      
    },
    {
      pattern: longrg,
      message: '请输入在正确的经纬度',
      trigger: 'blur'
    }
  ],
  lat: [
    {
      required: true,
      message: "请输入纬度",
      trigger: "blur",
    },
    {
      pattern: latreg,
      message: '请输入在正确的经纬度',
      trigger: 'blur'
    }
  ],
  radius: [
    {
      required: true,
      message: "请输入覆盖范围",
      trigger: "blur",
    },
  ],
  inputUrl: [
    {
      required: true,
      message: "请输入URL",
      trigger: "blur",
    },
  ],
};
// 飞行计划管理
export const flightPlanManagementFilterForm = [
  formItem.datetimerange({
    prop: "date",
    label: "预计起飞时间",
    placeholder: "请输入启动时间",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "planSer",
    label: "计划编号",
    placeholder: "请输入计划编号",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "station",
    label: "航空站点",
    placeholder: "请选择航空站点",
    options: [],
    defaultVal: undefined,
  }),
];
// 航线查询
export const airlineEnquiryFilterForm = [
  formItem.select({
    prop: "startStation",
    label: "起始航空站",
    options: [],
    placeholder: "请选择起始航空站",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "endStation",
    label: "终点航空站",
    options: [],
    placeholder: "请选择终点航空站",
    defaultVal: undefined,
  }),
];
// 救援管理
export const emergencyFilterForm = [
  formItem.input({
    prop: "flyMachineSer",
    label: "飞行器编号",
    placeholder: "请输入飞行器编号",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "reasons",
    label: "发起救援原因",
    placeholder: "请输入发起救援原因",
    defaultVal: undefined,
  }),
  formItem.datetimerange({
    prop: "date",
    label: "发起救援时间",
    placeholder: "请输入发起救援时间",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "status",
    label: "救援状态",
    options: [
      {
        label: '待救援',
        value: '待救援'
      },
      {
        label: '正在救援',
        value: '正在救援'
      },
      {
        label: '已救援',
        value: '已救援'
      },
    ],
    placeholder: "请选择救援状态",
    defaultVal: undefined,
  }),
];
export const emergencyDetailDrawerForm = [

  formItem.textarea({
    prop: "markResult",
    label: "救援结果备注",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "peopleName",
    label: "救援负责人",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "rescueTeam",
    label: "所属团队",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "dealPeople",
    label: "处理人",
    defaultVal: undefined,
  }),
  formItem.datetime({
    prop: "updateTime",
    label: "处理时间",
    defaultVal: undefined,
  }),
  
];
export const emergencyDrawerForm = [

  formItem.textarea({
    prop: "markResult",
    label: "救援结果备注",
    placeholder: "请输入救援结果备注",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "peopleName",
    label: "救援负责人",
    placeholder: "请输入救援负责人",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "rescueTeam",
    label: "所属团队",
    placeholder: "请输入救援负责人所属团队",
    defaultVal: undefined,
  }),
  
];
export const emergencyDrawerFormRules = {
  markResult: [
    {
      required: true,
      message: "请输入救援结果备注",
      trigger: "blur",
    },
  ],
  peopleName: [
    {
      required: true,
      message: "请输入救援负责人",
      trigger: "blur",
    },
  ],
  rescueTeam: [
    {
      required: true,
      message: "请输入救援负责人所属团队",
      trigger: "blur",
      
    }
  ]
};

// 告警管理
export const alarmFilterForm = [
  formItem.input({
    prop: "flyMachineSer",
    label: "飞行器编号",
    placeholder: "请输入飞行器编号",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "warningClass",
    label: "告警类型",
    options: [],
    placeholder: "请选择告警类型",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "status",
    label: "处理状态",
    options: [
      {
        label: '待处理',
        value: '待处理',
      },
      {
        label: '已处理',
        value: '已处理',
      },
    ],
    placeholder: "请选择处理状态",
    defaultVal: undefined,
  }),
];

export const alarmHelpDrawerForm = [
  formItem.radio({
    prop: "needRescue",
    label: "是否需要救援",
    options: [
      { label: '是', value: '是'},
      { label: '否', value: '否'},
    ],
    placeholder: "请选择是否需要救援",
    defaultVal: '是',
  }),
  formItem.select({
    prop: "reason",
    label: "发起救援原因",
    options: [
      { label: '设备故障', value: '设备故障'},
      { label: '电量不足', value: '电量不足'},
      { label: '油电不足', value: '油电不足'},
      { label: '人员健康救援', value: '人员健康救援'},
    ],
    placeholder: "请选择发起救援原因",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "resources",
    label: "可调配救援资源",
    options: [],
    placeholder: "请选择可调配救援资源",
    defaultVal: undefined,
  }),
  formItem.textarea({
    prop: "result",
    label: "发起救援备注",
    placeholder: "请输入救援备注内容",
    defaultVal: undefined,
  }),

]

export const alarmHelpDrawerFormRules = {
  needRescue: [
    {
      required: true,
      message: "请选择是否需要救援",
      trigger: "blur",
    },
  ],
  reason: [
    {
      required: true,
      message: "请选择发起救援原因",
      trigger: "blur",
    },
  ],
  resources: [
    {
      required: true,
      message: "请选择可调配救援资源",
      trigger: "blur",
      
    }
  ],
  result: [
    {
      required: true,
      message: "请输入救援备注内容",
      trigger: "blur",
      
    }
  ],
};
export const alarmDrawerForm = [
  formItem.radio({
    prop: "needRescue",
    label: "是否需要救援",
    options: [
      { label: '是', value: '是'},
      { label: '否', value: '否'},
    ],
    placeholder: "请选择是否需要救援",
    defaultVal: '否',
  }),
  formItem.textarea({
    prop: "result",
    label: "处理结果",
    placeholder: "请输入处理结果内容",
    defaultVal: undefined,
  })
]
export const alarmDrawerFormRules = {
  needRescue: [
    {
      required: true,
      message: "请选择是否需要救援",
      trigger: "blur",
    },
  ],
  result: [
    {
      required: true,
      message: "请输入救援备注内容",
      trigger: "blur",
      
    }
  ],
};
// 角色管理
export const roleFilterForm = [
  formItem.input({
    prop: "name",
    label: "角色名",
    placeholder: "请输入角色名",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "disabled",
    label: "启用状态",
    options: [
      {
        label: "启用",
        value: "启用",
      },
      {
        label: "禁用",
        value: "禁用",
      },
    ],
    placeholder: "请选择启用状态",
    defaultVal: undefined,
  }),
];
// 统计分析,按天统计
export const statisticsDayFilterForm = [
  formItem.select({
    prop: "type",
    // label: "启用状态",
    options: [
      {
        label: "按天统计",
        value: "按天统计",
      },
      {
        label: "按月统计",
        value: "按月统计",
      },
    ],
    defaultVal: '按天统计',
  }),
  formItem.daterange({
    prop: "date",
    label: "时间查询",
    placeholder: "请输入启动时间",
    defaultVal: [],
  })
];
// 统计分析,按月统计
export const statisticsMonthFilterForm = [
  formItem.select({
    prop: "type",
    // label: "启用状态",
    options: [
      {
        label: "按天统计",
        value: "按天统计",
      },
      {
        label: "按月统计",
        value: "按月统计",
      },
    ],
    defaultVal: '按月统计',
  }),
  formItem.monthrange({
    prop: "date",
    label: "时间查询",
    placeholder: "请输入启动时间",
    defaultVal: [],
  })
];

export const roleDrawerForm = [
  formItem.input({
    prop: "name",
    label: "角色名称",
    placeholder: "请输入角色名",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "disabled",
    label: "启用状态",
    options: [
      { label: "启用", value: "启用" },
      { label: "禁用", value: "禁用" },
    ],
    placeholder: "请选择启用状态",
    defaultVal: undefined,
  }),
  formItem.checkboxGroup({
    prop: "permissionIds",
    label: "权限分配",
    options: [],
    defaultVal: undefined,
  }),
];

export const roleDrawerFormRules = {
  name: [
    {
      required: true,
      message: "请输入角色名",
      trigger: "blur",
    },
  ],
  disabled: [
    {
      required: true,
      message: "请选择启用状态",
      trigger: "blur",
    },
  ],
  permissionIds: [
    {
      required: true,
      message: "请为该账号分配权限",
      trigger: "blur",
    },
  ],
};
// 用户管理
export const systemUserFilterForm = [
  formItem.input({
    prop: "userName",
    label: "用户账号",
    placeholder: "请输入用户账号",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "disabled",
    label: "启用状态",
    options: [
      { label: "启用", value: "启用" },
      { label: "禁用", value: "禁用" },
    ],
    placeholder: "请选择启用状态",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "roleName",
    label: "角色",
    options: [],
    placeholder: "请选择角色",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "authenticated",
    label: "是否认证",
    options: [
      { label: "是", value: "是" },
      { label: "否", value: "否" },
    ],
    placeholder: "请选择是否认证",
    defaultVal: undefined,
  }),
];
export const addSystemUserDrawerForm = [
  formItem.input({
    prop: "username",
    label: "用户账号",
    placeholder: "请输入手机号",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "roleName",
    label: "所属角色",
    options: [],
    placeholder: "请选择所属角色",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "disabled",
    label: "启用状态",
    options: [
      { label: "启用", value: "启用" },
      { label: "禁用", value: "禁用" },
    ],
    placeholder: "请选择启用状态",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "password",
    label: "用户密码",
    placeholder: "请输入用户密码",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "smsCode",
    label: "验证码",
    placeholder: "请输入验证码",
    defaultVal: undefined,
  }),
];
export const addSystemUserDrawerFormRules = {
  username: [
    {required: true, message: '请输入手机号', trigger: 'blur'},
    // {pattern: /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/, message: '请输入正确的手机号',trigger: 'blur'}
    {pattern: mobilePattern, message: '请输入正确的手机号', trigger: 'blur'}
  ],
  roleName: [
    {
      required: true,
      message: "请选择所属角色",
      trigger: "blur",
    },
  ],
  disabled: [
    {
      required: true,
      message: "请选择启用状态",
      trigger: "blur",
    },
  ],
  password: [
    {
      required: true,
      message: "请输入密码",
      trigger: "blur",
    }
  ],
  smsCode: [
    {
      required: true,
      message: "请输入手机验证码",
      trigger: "blur",
    },
  ],
};
export const editSystemUserDrawerForm = [
  formItem.input({
    prop: "username",
    label: "用户账号",
    placeholder: "请输入手机号",
    defaultVal: undefined,
    disabled: true,
  }),
  formItem.select({
    prop: "roleName",
    label: "所属角色",
    options: [],
    placeholder: "请选择所属角色",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "disabled",
    label: "启用状态",
    options: [
      { label: "启用", value: "启用" },
      { label: "禁用", value: "禁用" },
    ],
    placeholder: "请选择启用状态",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "authenticated",
    label: "是否认证",
    defaultVal: undefined,
    disabled: true,
  }),
  formItem.input({
    prop: "formattedSource",
    label: "用户来源",
    defaultVal: undefined,
    disabled: true,
  }),
  formItem.input({
    prop: "password",
    label: "用户密码",
    placeholder: "请输入用户密码",
    defaultVal: undefined,
  }),
];
export const editSystemUserDrawerFormRules = {
  disabled: [
    {
      required: true,
      message: "请选择启用状态",
      trigger: "blur",
    },
  ],
};
// 企业认证管理
export const enterpriseCertificationFilterForm = [
  formItem.input({
    prop: "userName",
    label: "用户账号",
    placeholder: "请输入用户账号",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "classify",
    label: "认证类型",
    options: [
      { label: "个人认证", value: "个人认证" },
      { label: "企业认证", value: "企业认证" },
    ],
    placeholder: "请选择认证类型",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "status",
    label: "认证状态",
    options: [
      { label: "认证成功", value: "认证成功" },
      { label: "认证失败", value: "认证失败" },
      { label: "待审核", value: "待审核" },
      { label: "未认证", value: "未认证" },
    ],
    placeholder: "请选择认证状态",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "company",
    label: "所属企业",
    placeholder: "请输入所属企业",
    defaultVal: undefined,
  }),
];
// 飞行员认证管理
export const pilotCertificationFilterForm = [
  formItem.input({
    prop: "userName",
    label: "用户账号",
    placeholder: "请输入用户账号",
    defaultVal: undefined,
  }),
  formItem.select({
    prop: "status",
    label: "认证状态",
    options: [
      { label: "认证成功", value: "认证成功" },
      { label: "认证失败", value: "认证失败" },
      { label: "待审核", value: "待审核" },
      { label: "未认证", value: "未认证" },
    ],
    placeholder: "请选择认证状态",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "company",
    label: "所属企业",
    placeholder: "请输入所属企业",
    defaultVal: undefined,
  }),
];

export const newAirlineForm = [
  formItem.input({
    prop: "routeSer",
    label: "航线编号",
    placeholder: "审核通过后自动获取编号",
    defaultVal: undefined,
    disabled: true,
  }),
  formItem.map({
    prop: "startingTerminal",
    label: "起始航站",
    placeholder: "请选择已有的航空港口站",
    defaultVal: undefined,
    limitNum: 1
  }),
  formItem.map({
    prop: "endTerminal",
    label: "终点航站",
    placeholder: "请选择已有的航空港口站",
    defaultVal: undefined,
    limitNum: 1
  }),
  formItem.map({
    prop: "dockingTerminal",
    label: "停靠航站",
    placeholder: "请选择已有的航空港口站",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "routeDistance",
    label: "航线长度",
    placeholder: "根据所选起始航站、终点航站及停靠航点自动计算",
    defaultVal: undefined,
    disabled: true,
  }),
  formItem.textarea({
    prop: "mark",
    label: "航线备注",
    placeholder: "注明航线创建的原因及用途，用于审核",
    defaultVal: undefined,
  }),
];
export const newAirlineFormRules = {
  startingTerminal: [
    {
      required: true,
      message: "请选择已有的航空港口站",
      trigger: "blur",
    },
  ],
  endTerminal: [
    {
      required: true,
      message: "请选择已有的航空港口站",
      trigger: "blur",
    },
  ],
  dockingTerminal: [
    {
      required: true,
      message: "请选择已有的航空港口站",
      trigger: "blur",
    },
  ],
  mark: [
    {
      required: true,
      message: "请注明航线创建的原因及用途，用于审核",
      trigger: "blur",
    },
  ],
};

export const enterpriseAuditForm = [
  formItem.input({
    prop: "userName",
    label: "用户账号",
    placeholder: "请输入用户账号",
    defaultVal: undefined,
    disabled: true
  }),
  formItem.input({
    prop: "authenticatedName",
    label: "申请人",
    placeholder: "请输入申请人",
    defaultVal: undefined,
    disabled: true
  }),
  formItem.select({
    prop: "classify",
    label: "认证类型",
    options: [
      { label: "个人认证", value: "个人认证" },
      { label: "企业认证", value: "企业认证" },
    ],
    placeholder: "请选择认证类型",
    defaultVal: undefined,
    disabled: true
  }),
  formItem.input({
    prop: "idCardNum",
    label: "身份证",
    placeholder: "请输入身份证",
    defaultVal: undefined,
    disabled: true
  }),
  formItem.input({
    prop: "company",
    label: "所属企业",
    placeholder: "请输入所属企业",
    defaultVal: undefined,
    disabled: true
  }),
  formItem.input({
    prop: "socialCreditCode",
    label: "统一社会信用代码",
    placeholder: "请输入统一社会信用代码",
    defaultVal: undefined,
    disabled: true
  }),
  formItem.datetime({
    prop: "createTime",
    label: "申请认证时间",
    placeholder: "请输入申请认证时间",
    defaultVal: undefined,
    disabled: true
  }),
  formItem.upload({
    prop: "fileUrl",
    label: "营业执照",
    defaultVal: [],
    limitNum: 1,
    disabled: true
  }),
  formItem.select({
    prop: "status",
    label: "认证状态",
    options: [
      { label: "认证成功", value: "认证成功" },
      { label: "认证失败", value: "认证失败" },
      { label: "待审核", value: "待审核" },
      { label: "未认证", value: "未认证" },
    ],
    placeholder: "请选择认证状态",
    defaultVal: undefined,
    disabled: true
  }),
  formItem.textarea({
    prop: "mark",
    label: "认证失败原因",
    placeholder: "注明认证失败原因",
    defaultVal: undefined,
  }),
];
export const pilotReviewForm = [
  formItem.input({
    prop: "userName",
    label: "用户账号",
    placeholder: "请输入用户账号",
    defaultVal: undefined,
    disabled: true
  }),
  formItem.input({
    prop: "authenticatedName",
    label: "申请人",
    placeholder: "请输入申请人",
    defaultVal: undefined,
    disabled: true
  }),
  formItem.input({
    prop: "idCardNum",
    label: "身份证",
    placeholder: "请输入身份证",
    defaultVal: undefined,
    disabled: true
  }),
  formItem.input({
    prop: "company",
    label: "所属企业",
    placeholder: "请输入所属企业",
    defaultVal: undefined,
    disabled: true
  }),
  formItem.input({
    prop: "socialCreditCode",
    label: "统一社会信用代码",
    placeholder: "请输入统一社会信用代码",
    defaultVal: undefined,
    disabled: true
  }),
  formItem.datetime({
    prop: "createTime",
    label: "申请认证时间",
    placeholder: "请输入申请认证时间",
    defaultVal: undefined,
    disabled: true
  }),
  formItem.upload({
    prop: "fileUrl",
    label: "飞行员证书",
    defaultVal: [],
    limitNum: 1,
    disabled: true
  }),
  formItem.select({
    prop: "status",
    label: "认证状态",
    options: [
      { label: "认证成功", value: "认证成功" },
      { label: "认证失败", value: "认证失败" },
      { label: "待审核", value: "待审核" },
      { label: "未认证", value: "未认证" },
    ],
    placeholder: "请选择认证状态",
    defaultVal: undefined,
    disabled: true
  }),
  formItem.textarea({
    prop: "mark",
    label: "认证失败原因",
    placeholder: "注明认证失败原因",
    defaultVal: undefined,
  }),
];

export const changePhoneForm = [
  formItem.input({
    prop: "mobile",
    label: "新手机",
    placeholder: "请输入新手机号码",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "smsCode",
    label: "验证码",
    placeholder: "请输入验证码",
    defaultVal: undefined,
  }),
];
export const changePhoneFormRule = {
  mobile: [
    {required: true, message: '请输入手机号', trigger: 'blur'},
    // {pattern: /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/, message: '请输入正确的手机号',trigger: 'blur'}
    {pattern: mobilePattern, message: '请输入正确的手机号',trigger: 'blur'}
  ],
  smsCode: [
    {
      required: true,
      message: "请输入验证码",
      trigger: "blur",
    },
  ],
};
export const changePasswordForm = [
  formItem.input({
    prop: "userName",
    label: "用户账号",
    placeholder: "请输入用户账号",
    defaultVal: undefined,
    disabled: true,
  }),
  formItem.input({
    prop: "smsCode",
    label: "验证码",
    placeholder: "请输入验证码",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "password",
    label: "密码",
    placeholder: "请输入密码",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "confirmPassword",
    label: "确认密码",
    placeholder: "请再次输入密码",
    defaultVal: undefined,
  }),
];
export const changePasswordFormRule = {
  smsCode: [
    {
      required: true,
      message: "请输入验证码",
      trigger: "blur",
    },
  ],
  password: [
    {
      required: true,
      message: "请输入密码",
      trigger: "blur",
    },
  ],
  confirmPassword: [
    {
      required: true,
      message: "请再次输入密码",
      trigger: "blur",
    },
  ],
};
export const enterpriseAuthenticationForm = [
  formItem.select({
    prop: "classify",
    label: "认证类型",
    options: [
      { label: "个人认证", value: "个人认证" },
      { label: "企业认证", value: "企业认证" },
    ],
    placeholder: "请选择认证类型",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "authenticatedName",
    label: "认证名称",
    placeholder: "请输入认证名称",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "idCardNum",
    label: "身份证号码",
    placeholder: "请输入身份证号码",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "company",
    label: "所属企业",
    placeholder: "请输入所属企业",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "socialCreditCode",
    label: "统一社会信用代码",
    placeholder: "请输入统一社会信用代码",
    defaultVal: undefined,
  }),
  formItem.upload({
    prop: "fileUrl",
    label: "营业执照",
    defaultVal: [],
    limitNum: 1,
  }),
];

export const personalCertificateFormRule = {
  classify: [
    {
      required: true,
      message: "请选择认证类型",
      trigger: "blur",
    },
  ],
  authenticatedName: [
    {
      required: true,
      message: "请输入认证名称",
      trigger: "blur",
    },
  ],
  idCardNum: [
    {
      required: true,
      message: "请输入身份证号码",
      trigger: "blur",
    },
    {
      pattern: idCardPattern,
      message: "请输入正确的身份证号码"
    },
  ],
};
export const enterpriseAuthenticationFormRule = {
  classify: [
    {
      required: true,
      message: "请选择认证类型",
      trigger: "blur",
    },
  ],
  authenticatedName: [
    {
      required: true,
      message: "请输入认证名称",
      trigger: "blur",
    },
  ],
  idCardNum: [
    { required: true, message: '请输入身份证号码', trigger: 'blur' },
    { pattern: idCardPattern, message: '请输入正确的身份证号码', trigger: 'blur' }
  ],
  company: [
    {
      required: true,
      message: "请输入所属企业",
      trigger: "blur",
    },
  ],
  socialCreditCode: [
    { required: true, message: '请输入18位统一社会信用代码', trigger: 'blur' },
    { pattern: codePattern, message: '请输入18位统一社会信用代码', trigger: 'blur' }
  ],
  fileUrl: [
    {
      required: true,
      message: "请上传营业执照",
      trigger: "blur",
    },
  ],
};

export const pilotCertificationForm = [
  formItem.input({
    prop: "authenticatedName",
    label: "认证名称",
    placeholder: "请输入认证名称",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "idCardNum",
    label: "身份证号码",
    placeholder: "请输入身份证号码",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "company",
    label: "所属企业",
    placeholder: "请输入所属企业",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "socialCreditCode",
    label: "统一社会信用代码",
    placeholder: "请输入统一社会信用代码",
    defaultVal: undefined,
  }),
  formItem.upload({
    prop: "fileUrl",
    label: "飞行员证书",
    defaultVal: [],
    limitNum: 1,
  }),
];

export const pilotCertificationFormRule = {
  authenticatedName: [
    {
      required: true,
      message: "请输入认证名称",
      trigger: "blur",
    },
  ],
  idCardNum: [
    { required: true, message: '请输入身份证号码', trigger: 'blur' },
    { pattern: idCardPattern, message: '请输入正确的身份证号码', trigger: 'blur' }
  ],
  fileUrl: [
    {
      required: true,
      message: "请上传飞行员证书",
      trigger: "blur",
    },
  ],
};

export const newFlightPlanForm = [
  formItem.select({
    prop: "flyMachineSer",
    label: "飞行器编号",
    options: [],
    placeholder: "请选择飞行器编号",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "flyClass",
    label: "飞行器类型",
    placeholder: "根据选择的飞行器编号，自动获取飞行器类型",
    defaultVal: undefined,
    disabled: true,
  }),
  formItem.select({
    prop: "planClass",
    label: "计划类型",
    options: [
      {
        label: "市内通勤",
        value: "市内通勤",
      },
      {
        label: "省内城际",
        value: "省内城际",
      },
    ],
    placeholder: "请选择计划类型",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "planName",
    label: "计划名称",
    placeholder: "请输入计划名称",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "planSer",
    label: "计划编号",
    placeholder: "请输入计划编号",
    defaultVal: undefined,
  }),
  formItem.input({
    prop: "mark",
    label: "备注",
    placeholder: "请输入备注",
    defaultVal: undefined,
  }),
  formItem.map({
    prop: "startingTerminal",
    label: "起始航站",
    placeholder: "请选择已有的航空港口站",
    defaultVal: undefined,
    limitNum: 1

  }),
  formItem.map({
    prop: "endTerminal",
    label: "终点航站",
    placeholder: "请选择已有的航空港口站",
    defaultVal: undefined,
    limitNum: 1

  }),
  formItem.map({
    prop: "dockingTerminal",
    label: "停靠航站",
    placeholder: "请选择已有的航空港口站",
    defaultVal: undefined,
  }),
  formItem.datetime({
    prop: "launchTime",
    label: "预计起飞时间",
    placeholder: "请输入预计起飞时间",
    defaultVal: undefined,
  }),
  formItem.datetime({
    prop: "landTime",
    label: "预计降落时间",
    placeholder: "请输入预计降落时间",
    defaultVal: undefined,
  }),
];
export const newFlightPlanFormRule = {
  flyMachineSer: [
    {
      required: true,
      message: "请选择飞行器编号",
      trigger: "blur",
    },
  ],
  planClass: [
    {
      required: true,
      message: "请选择计划类型",
      trigger: "blur",
    },
  ],
  planName: [
    {
      required: true,
      message: "请输入计划名称",
      trigger: "blur",
    },
  ],
  planSer: [
    {
      required: true,
      message: "请输入计划编号",
      trigger: "blur",
    },
  ],
  mark: [
    {
      required: true,
      message: "请输入备注",
      trigger: "blur",
    },
  ],
  startingTerminal: [
    {
      required: true,
      message: "请选择已有的航空港口站",
      trigger: "blur",
    },
  ],
  endTerminal: [
    {
      required: true,
      message: "请选择已有的航空港口站",
      trigger: "blur",
    },
  ],
  dockingTerminal: [
    {
      required: true,
      message: "请选择已有的航空港口站",
      trigger: "blur",
    },
  ],
  launchTime: [
    {
      required: true,
      message: "请输入预计起飞时间",
      trigger: "blur",
    },
  ],
  landTime: [
    {
      required: true,
      message: "请输入预计降落时间",
      trigger: "blur",
    },
  ],
};

// 卫星遥感热源监测
export const satelliteFilterForm = [
  // formItem.select({
  //   prop: "checkStatus",
  //   label: "核查状态",
  //   options: [
  //     {
  //       label: "已核查",
  //       value: "已核查",
  //     },
	 //  {
	 //    label: "核查中",
	 //    value: "核查中",
	 //  },
	 //  {
	 //    label: "未核查",
	 //    value: "未核查",
	 //  },
  //   ],
  //   placeholder: "请选择核查状态",
  //   defaultVal: undefined,
  // }),
  formItem.select({
    prop: "fireStatus",
    label: "热点状态",
    options: [
      {
        label: "已熄灭",
        value: "已熄灭",
      },
  	  {
  	    label: "正在燃烧",
  	    value: "正在燃烧",
  	  },
  	  {
  	    label: "未找到",
  	    value: "未找到",
  	  },
    ],
	clearable:true,
    placeholder: "请选择核查状态",
    defaultVal: undefined,
  }),
  formItem.daterange({
    prop: "date",
    label: "日期",
    placeholder: "请选择日期",
    defaultVal: [],
  })
];